const webHost = process.env.NODE_ENV === 'production'? 'http://www.timesaas.cn': 'http://prepare.timesaas.cn';

export default webHost


// WEBPACK FOOTER //
// ./src/api/config.js